import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("coc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve an image_url (e.g. "/api/images/<id>") to an absolute URL.
export const resolveImg = (url) => {
  if (!url) return null;
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
};

// Resolve a thumbnail that may be a data: URI (from a docx-embedded image),
// an absolute http URL, or a relative "/api/images/.." path.
export const thumbSrc = (thumb) => {
  if (!thumb) return null;
  if (thumb.startsWith("data:") || thumb.startsWith("http")) return thumb;
  return `${BACKEND_URL}${thumb}`;
};

// Strip HTML to plain text for excerpts.
export const toExcerpt = (html, len = 180) => {
  const withSpaces = (html || "").replace(/<\/(p|div|h[1-6]|li|blockquote)>/gi, " $& ").replace(/<br\s*\/?>/gi, " ");
  const tmp = document.createElement("div");
  tmp.innerHTML = withSpaces;
  const text = (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
  return text.length > len ? text.slice(0, len).trim() + "\u2026" : text;
};

export default api;
